// Timer-free loop clock: maps real wall-clock to a position within the captured
// 3-day span, compressed to a 4-minute loop. Re-anchors on speed/scrub change so
// the position is continuous across control changes. Mirrors demoFleet.js:15-45.

export const SPAN_SECONDS = 259_200; // 2026-06-08T07:00Z → 2026-06-11T07:00Z
export const LOOP_REAL_MS = 240_000; // one full pass at speed 1 (~1080x)

let _speed = 1;
let _paused = false;
let _baseFrac = 0;          // span fraction captured at last re-anchor
let _baseRealMs = 0;        // wall-clock ms at last re-anchor
let _anchored = false;

function nowMs(now?: number): number {
  return typeof now === "number" ? now : Date.now();
}

function currentFrac(now?: number): number {
  const t = nowMs(now);
  if (!_anchored) { _baseRealMs = t; _anchored = true; }
  if (_paused) return _baseFrac;
  const advanced = ((t - _baseRealMs) * _speed) / LOOP_REAL_MS;
  let f = (_baseFrac + advanced) % 1;
  if (f < 0) f += 1;
  return f;
}

export function demoSpanSeconds(now?: number): number {
  return currentFrac(now) * SPAN_SECONDS;
}

function reanchor(now?: number): void {
  _baseFrac = currentFrac(now);
  _baseRealMs = nowMs(now);
  _anchored = true;
}

export function setSpeed(mult: number, now?: number): void {
  reanchor(now);
  _speed = Math.max(0, mult);
  _paused = _speed === 0;
}

export function setProgress(frac: number, now?: number): void {
  _baseFrac = ((frac % 1) + 1) % 1;
  _baseRealMs = nowMs(now);
  _anchored = true;
}

export function getProgress(now?: number): number { return currentFrac(now); }
export function getSpeed(): number { return _speed; }
export function isPaused(): boolean { return _paused; }
